import React from 'react'
import { useResponsive } from '@linqpal/components/src/hooks'
import { BtAlert, BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'

export default ({ visible, onClose }) => {
  const { sm } = useResponsive()
  const { t } = useTranslation('global')

  return (
    <BtAlert
      visible={visible}
      onClose={onClose}
      title={t('Wallet.account_alert_title')}
      titleStyle={sm ? {} : { fontWeight: '600', fontSize: 20 }}
      width={sm ? 500 : 330}
      type={'danger'}
      buttons={[
        {
          label: t('Wallet.account_alert_button'),
          onPress: onClose,
        },
      ]}
    >
      <BtText
        size={sm ? 18 : 16}
        style={{ lineHeight: 26, textAlign: 'center' }}
      >
        {t('Wallet.account_alert_text')}
      </BtText>
    </BtAlert>
  )
}
